<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_ix"></a>Sharing Sacred Spaces in<br/>the Mediterranean<a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?9720b8b0